/**
 * Rich automotive custom widget registrations.
 * @see docs/repo-modularity.md
 */
import './gauges';
import './infotainment';
import './indicators';
import './diagnostics';
import './cluster';
